/**
 * Soft bundle add-to-cart for product detail pages only.
 */
(function () {
  if (window.SoftBundlePdp && window.SoftBundlePdp.initialized) return;

  function getCartAddUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_add_url) || '/cart/add.js';
  }

  function buildBundleItems(buttonEl) {
    const variantIds = (buttonEl.getAttribute('data-pdp-bundle-variant-ids') || '').split(',').filter(Boolean);
    const quantities = (buttonEl.getAttribute('data-pdp-bundle-quantities') || '').split(',');
    const propertyKey = buttonEl.getAttribute('data-pdp-line-item-property-key');

    return variantIds
      .map(function (id, index) {
        const item = {
          id: parseInt(id, 10),
          quantity: parseInt(quantities[index] || '1', 10),
        };
        if (propertyKey) {
          item.properties = {};
          item.properties[propertyKey] = 'true';
        }
        return item;
      })
      .filter(function (item) {
        return item.id && item.quantity > 0;
      });
  }

  function getCartVariantQuantity(cart, variantId) {
    if (!cart || !cart.items) return 0;
    const match = cart.items.find(function (item) {
      return item.variant_id === variantId;
    });
    return match ? match.quantity : 0;
  }

  function validateInventory(buttonEl, cart) {
    const variantIds = (buttonEl.getAttribute('data-pdp-bundle-variant-ids') || '').split(',').filter(Boolean);
    const quantities = (buttonEl.getAttribute('data-pdp-bundle-quantities') || '').split(',');
    const managedFlags = (buttonEl.getAttribute('data-pdp-bundle-inventory-managed') || '').split(',');
    const inventoryQtys = (buttonEl.getAttribute('data-pdp-bundle-inventory-quantities') || '').split(',');
    const inventoryPolicies = (buttonEl.getAttribute('data-pdp-bundle-inventory-policies') || '').split(',');

    for (let i = 0; i < variantIds.length; i++) {
      const variantId = parseInt(variantIds[i], 10);
      const requiredQty = parseInt(quantities[i] || '1', 10);
      if (!variantId || requiredQty < 1) continue;

      const isManaged = managedFlags[i] === 'true';
      const policy = (inventoryPolicies[i] || 'deny').toLowerCase();
      if (!isManaged || policy === 'continue') continue;

      const inventoryQty = parseInt(inventoryQtys[i] || '0', 10);
      const cartQty = getCartVariantQuantity(cart, variantId);
      const remainingQty = inventoryQty - cartQty;

      if (remainingQty < requiredQty) {
        return {
          valid: false,
          message: 'Not enough stock available for this bundle. Please check your cart and try again.',
        };
      }
    }

    return { valid: true };
  }

  function getCartErrorMessage(res, fallback) {
    if (!res) return fallback;
    if (res.message) return res.message;
    if (res.description) return res.description;
    if (res.errors) {
      if (typeof res.errors === 'string') return res.errors;
      const parts = [];
      Object.keys(res.errors).forEach(function (key) {
        const val = res.errors[key];
        if (Array.isArray(val)) parts.push(val.join(', '));
        else if (val) parts.push(String(val));
      });
      if (parts.length) return parts.join(' ');
    }
    return fallback;
  }

  function dispatchCartUpdate(buttonEl, res, variantId, addQuantity) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          sourceId: String(variantId),
          data: {
            source: 'pdp-soft-bundle',
            itemCount: addQuantity,
            addQuantity: addQuantity,
            variantId: String(variantId),
            productId: buttonEl.getAttribute('data-product-id'),
            productTitle: buttonEl.getAttribute('data-product-title'),
            productType: buttonEl.getAttribute('data-product-type'),
            productPrice: buttonEl.getAttribute('data-product-price'),
            productImage: buttonEl.getAttribute('data-product-image'),
            productInStock: buttonEl.getAttribute('data-product-in-stock'),
            sections: (res && res.sections) || {},
          },
        },
      })
    );
  }

  function restoreButtonState(button, textElement, originalText) {
    button.disabled = false;
    button.style.cursor = '';
    button.style.opacity = '';
    if (textElement) {
      textElement.textContent = originalText;
    } else {
      button.textContent = originalText;
    }
  }

  function setButtonLoading(button, textElement) {
    button.disabled = true;
    button.style.cursor = 'not-allowed';
    button.style.opacity = '0.7';
    if (textElement) {
      textElement.textContent = 'Adding..';
    } else {
      button.textContent = 'Adding..';
    }
  }

  function getErrorEl(buttonEl) {
    const area = buttonEl.closest('.buy-buttons-block__atc-area');
    return area ? area.querySelector('.soft-bundle-pdp-atc-error') : null;
  }

  function showError(buttonEl, message) {
    const errorEl = getErrorEl(buttonEl);
    if (errorEl) {
      errorEl.textContent = message;
      errorEl.hidden = false;
      errorEl.classList.remove('hidden');
      scrollErrorIntoView(errorEl, buttonEl);
      return;
    }
    alert(message);
  }

  function scrollErrorIntoView(errorEl, buttonEl) {
    if (!errorEl) return;

    const fromSticky = buttonEl && buttonEl.getAttribute('data-puppet') === 'true';
    const rect = errorEl.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const inView = rect.top >= 0 && rect.bottom <= viewportHeight;

    if (!fromSticky && inView) return;

    requestAnimationFrame(function () {
      errorEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      errorEl.focus({ preventScroll: true });
    });
  }

  function clearError(buttonEl) {
    const errorEl = getErrorEl(buttonEl);
    if (!errorEl) return;
    errorEl.textContent = '';
    errorEl.hidden = true;
    errorEl.classList.add('hidden');
  }

  function addToCart(buttonEl) {
    const bundleItems = buildBundleItems(buttonEl);
    if (!bundleItems.length) {
      showError(buttonEl, 'This product is currently out of stock.');
      return Promise.reject(new Error('no-items'));
    }

    return fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        const inventoryCheck = validateInventory(buttonEl, cart);
        if (!inventoryCheck.valid) {
          showError(buttonEl, inventoryCheck.message);
          return Promise.reject(new Error('inventory'));
        }

        return fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ items: bundleItems }),
        })
          .then(function (r) {
            return r.json();
          })
          .then(function (res) {
            if (res.status) {
              showError(buttonEl, getCartErrorMessage(res, 'Could not add to cart. Please try again.'));
              return Promise.reject(new Error('cart-error'));
            }

            const addQuantity = bundleItems.reduce(function (total, item) {
              return total + item.quantity;
            }, 0);

            return fetch('/cart.js')
              .then(function (r) {
                return r.json();
              })
              .then(function (updatedCart) {
                dispatchCartUpdate(buttonEl, res, bundleItems[0].id, updatedCart.item_count || addQuantity);
                return res;
              })
              .catch(function () {
                dispatchCartUpdate(buttonEl, res, bundleItems[0].id, addQuantity);
                return res;
              });
          });
      });
  }

  function bindButton(buttonEl) {
    if (!buttonEl || buttonEl.dataset.pdpSoftBundleBound === 'true') return;
    if (buttonEl.getAttribute('data-pdp-soft-bundle') !== 'true') return;

    buttonEl.dataset.pdpSoftBundleBound = 'true';

    buttonEl.addEventListener('click', function (e) {
      e.preventDefault();
      if (buttonEl.disabled) return;

      clearError(buttonEl);

      const textElement = buttonEl.querySelector('.add-to-cart-text__content span') || buttonEl.querySelector('span') || buttonEl;
      const originalText = textElement.textContent || textElement.innerText || buttonEl.textContent || 'Add to Cart';

      setButtonLoading(buttonEl, textElement);

      addToCart(buttonEl)
        .catch(function (err) {
          if (err && (err.message === 'inventory' || err.message === 'no-items' || err.message === 'cart-error')) return;
          console.error(err);
          showError(buttonEl, 'Could not add to cart. Please try again.');
        })
        .finally(function () {
          restoreButtonState(buttonEl, textElement, originalText);
        });
    });
  }

  function init(scope) {
    const root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('[data-pdp-soft-bundle="true"]').forEach(bindButton);
  }

  window.SoftBundlePdp = {
    initialized: true,
    init: init,
    bindButton: bindButton,
    addToCart: addToCart,
  };
})();
